import React, { useEffect, useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import { connect } from 'react-redux';
import Instruction from '../Instruction';
import SettingPopup from './SettingPopup.js';
import { useNavigate } from 'react-router-dom';


function QuestionnairePage(props) {
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const { fontSize } = useSetting();
    const [data, setData] = useState(props.data)
    const [pageIndex, setPageIndex] = useState(0);
    const [showInstructions, setShowInstructions] = useState(false);
    const [isSettingMenuVisible, setIsSettingMenuVisible] = useState(false);
    const [startTime, setStartTime] = useState(new Date().getTime());
    const [timer, setTimer] = useState('10:00');//10 minutes
    const [timeSpentOnQuestion, setTimeSpentOnQuestion] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setTimeSpentOnQuestion(prev => prev + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [pageIndex]);
    useEffect(() => {
        function updateTimer() {
            const now = new Date().getTime();
            const elapsed = now - startTime;
            const remaining = Math.max(0, 10 * 60 * 1000 - elapsed); // 10 minutes in milliseconds
            const minutes = Math.floor(remaining / 60000);
            const seconds = Math.floor((remaining % 60000) / 1000);
            setTimer(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
        }

        const interval = setInterval(updateTimer, 1000);
        return () => clearInterval(interval);
    }, [startTime]);

    const navigate = useNavigate();

    function isTableAnswerCompleted(section) {
        if (section.type === 'table' || (!section.type)) {
            if (section.questions) {
                for (let question of section.questions) {
                    if (!question.answer) {
                        return false;
                    }
                }
            }
        } else {
            if (!section.answer) {
                return false;
            }
        }
        return true;
    }

    const isAllQuestionCompleted = () => {
        let isCompleted = true;
        let sections = data?.sections?.[pageIndex];
        for (let section of sections) {
            isCompleted = isTableAnswerCompleted(section);
            if (!isCompleted) {
                break;
            }
        }
        return isCompleted;
    }
    return (
        <div className='w-full flex flex-col h-full' style={{ fontSize }}>

            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }} onClick={() => setIsSettingMenuVisible(!isSettingMenuVisible)}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
                <div className='flex flex-row gap-[8px]'>
                    <div className='flex items-center justify-center'>
                        <div className='text-white bg-[#003A57] py-[8px] px-[24px] rounded-[4px]' style={{ fontSize: fontSize }}>{timer}</div>
                    </div>
                </div>
                <div className='flex flex-row gap-[8px] flex-1 justify-end'>
                    <button>
                        <img alt='說明' src='/secondary/btn1.png' onClick={() => { setShowInstructions(true) }} />
                    </button>
                    <button>
                        <img alt='上一頁' src='/secondary/btn2.png' onClick={() => { 
                            if (pageIndex > 0) { 
                                let previousPageIndex = pageIndex-1
                                setPageIndex(previousPageIndex) 
                                let data_ = { ...data }
                                data_.sections[previousPageIndex+1][0].timeSpent = timeSpentOnQuestion;
                                setData(data_);
                                setTimeSpentOnQuestion(data_.sections[previousPageIndex][0].timeSpent||0);
                            } 
                        }} />
                    </button>
                    <button>
                        <img alt='下一頁' src='/secondary/btn3.png' onClick={() => {
                            if (!isAllQuestionCompleted()) {
                                alert('請完成所有問題後再進行下一頁。')
                                return
                            }
                            if (pageIndex < data?.sections?.length - 1) {
                                let nextIndex = pageIndex + 1;
                                setPageIndex(nextIndex)
                                let data_ = { ...data }
                                data_.sections[nextIndex-1][0].timeSpent = timeSpentOnQuestion;
                                setData(data_);
                                setTimeSpentOnQuestion(data_.sections[nextIndex][0].timeSpent||0);
                            }
                        }} />
                    </button>
                </div>


            </div>

            <div className='flex flex-col w-full justify-center items-center  mt-[16px]'>
                <div className='w-full text-white font-bold flex flex-col text-left px-[24px] py-[8px]' style={{ background: 'linear-gradient(to left, #55A8E0, #1C7595, #3B77A4)' }}>
                    {props.data?.name}
                    <br />
                    <div dangerouslySetInnerHTML={{ __html: props.data?.subtitle }} />
                </div>
            </div>

            <div className='w-full flex relative h-[17px] bg-[#D9D9D9] flex-col items-start'>
                {/*progress bar*/}
                <div className='h-[17px] bg-[#01B49D]' style={{ width: `${((pageIndex + 1) / data?.sections?.length) * 100}%` }} />
            </div>



            <div className='w-full flex flex-col items-center flex-1 overflow-auto noto-san-hk bg-[#F8FAFB]'>
                <div className='w-full flex flex-col items-start max-w-[1200px] p-[64px] gap-[64px]'>
                    {data?.sections?.[pageIndex]?.map((section, sectionIndex) => (
                        section.type === 'date' ?
                            <div className='flex flex-col w-full gap-[16px]' key={sectionIndex}>
                                <div className='w-full flex flex-row items-center font-[700] justify-start'>
                                    <div className='mr-[32px]'>
                                        {section.question}
                                    </div>
                                    <input
                                        type="date"
                                        className='bg-[#E4E5E6]'
                                        value={section?.answer || ''}
                                        onChange={(e) => {
                                            let newData = { ...data }
                                            newData.sections[pageIndex][sectionIndex].answer = e.target.value
                                            setData(newData)
                                        }}
                                    />
                                </div>

                            </div>
                            : section.type === 'single-choice' ?
                                <div className='flex flex-col w-full gap-[16px]' key={sectionIndex}>
                                    <div className='w-full flex flex-row items-start font-[700]'>
                                        <div className='flex-1'>
                                            {section.question}
                                        </div>
                                    </div>
                                    <div className='flex flex-col w-full gap-[16px]'>
                                        {section?.options?.map((option, optionIndex) => (
                                            <div key={optionIndex} className='w-full flex flex-row items-center gap-[16px] justify-start'>
                                                <input
                                                    key={optionIndex}
                                                    type="radio"
                                                    value={option}
                                                    checked={section?.answer === option}
                                                    onChange={() => {
                                                        let newData = { ...data }
                                                        newData.sections[pageIndex][sectionIndex].answer = option
                                                        setData(newData)
                                                    }}
                                                />
                                                {option}
                                                {option.includes('其他（請寫出）') &&
                                                    <input
                                                        type="text"
                                                        className='bg-[#E4E5E6] border-b-black border-b-[1px]'
                                                        value={section?.answerDetail || ''}
                                                        onChange={(e) => {
                                                            let newData = { ...data }
                                                            newData.sections[pageIndex][sectionIndex].answerDetail = e.target.value
                                                            setData(newData)
                                                        }}
                                                    />
                                                }
                                            </div>
                                        ))}

                                    </div>
                                </div>
                                :
                                <div className='flex flex-col w-full gap-[16px]' key={sectionIndex}>
                                    {section.hint && (
                                        <div className='w-full text-[#9D3D05] mb-[16px] font-bold'>
                                            <div dangerouslySetInnerHTML={{ __html: section.hint }} />
                                        </div>
                                    )}
                                    <div className='w-full flex flex-row items-start font-[700] mb-[32px]'>
                                        <div className='flex-1'>
                                            {section.title}
                                        </div>
                                        <div className='w-[600px] flex flex-row items'>
                                            {
                                                section?.options?.map((option, optionIndex) => (
                                                    <div key={optionIndex} className='w-[120px] px-[20px] text-center'>
                                                        {option}
                                                    </div>
                                                ))
                                            }
                                        </div>

                                    </div>
                                    {
                                        section?.questions?.map((question, questionIndex) => (
                                            <div key={questionIndex} className='w-full flex flex-row items-start font-[500]'>
                                                <div className='flex-1'>
                                                    {question.question}
                                                </div>
                                                <div className='w-[600px] flex flex-row items items-center h-full'>
                                                    {
                                                        section?.options?.map((option, optionIndex) => (
                                                            <div key={optionIndex} className='w-[120px] px-[20px] text-center flex flex-row items-center justify-center'>
                                                                <input
                                                                    type="radio"
                                                                    className='w-[20px] h-[20px]'
                                                                    name={`question-${questionIndex}`}
                                                                    value={option}
                                                                    checked={section?.questions[questionIndex]?.answer === option}
                                                                    onChange={() => {
                                                                        let newData = { ...data }
                                                                        newData.sections[pageIndex][sectionIndex].questions[questionIndex].answer = option
                                                                        setData(newData)
                                                                    }}
                                                                />
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>

                    ))}
                </div>

            </div>
            <div className='flex flex-row justify-center bg-[#F8FAFB] py-[16px]'>
                <button onClick={() => {
                    if (!isAllQuestionCompleted()) {
                        alert(pageIndex < data?.sections?.length - 1 ? '請完成所有問題後再進行下一頁。' : '請完成所有問題後再提交。')
                        return
                    }
                    if (pageIndex < data?.sections?.length - 1) {
                       
                        let nextIndex = pageIndex + 1;
                        setPageIndex(nextIndex)
                        let data_ = { ...data }
                        data_.sections[nextIndex-1][0].timeSpent = timeSpentOnQuestion;
                        setData(data_);
                        setTimeSpentOnQuestion(data_.sections[nextIndex][0].timeSpent||0);
                        return
                    } else {
                        let data_ = { ...data }
                        data_.sections[pageIndex][0].timeSpent = timeSpentOnQuestion;
                        setData(data_);
                        setShowConfirmPopup(true)
                    }
                }} className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                    <div className='rounded-full px-[48px] py-[6px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                        {pageIndex === data?.sections?.length - 1 ?
                            (props.session === 0 ? '提交並進入問卷第一部分' : props.session === 1 ? '提交並進入短篇閱讀題' : '提交')
                            : '下一頁'
                        }
                    </div>
                </button>
            </div>
            {showConfirmPopup && <div className='absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white bg-opacity-50 noto-san-hk font-bold' style={{ backdropFilter: 'blur(18px)' }}>
                <div className='bg-white p-[24px] rounded-[8px] flex flex-col items-center gap-[16px]' style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundImage: 'url(/secondary/bg7.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className='text-[#6E0526] font-bold mb-[16px]'>小提示</div>
                    <div className='mb-[16px] text-center'>提交後將不能返回修改本部分答案，<br />是否繼續？</div>
                    <div className='flex flex-row gap-[16px]'>
                        <button className='px-[16px] py-[8px] text-black rounded-[4px] min-w-[200px] text-center rounded-full' style={{ background: 'linear-gradient(to bottom, #BEBEBE80, #FFFFFF)' }} onClick={() => setShowConfirmPopup(false)}>返回檢查</button>
                        <button className='px-[16px] py-[8px] bg-[#007A83] text-white rounded-[4px] min-w-[200px] text-center rounded-full' onClick={() => {
                            props.onSubmit(data)
                        }}>確認</button>
                    </div>
                </div>
            </div>}
            {showInstructions && (
                <Instruction close={() => setShowInstructions(false)} />
            )}

            {isSettingMenuVisible && (
                <SettingPopup onClose={() => { navigate('/platform2/research-practices') }} onReturn={() => setIsSettingMenuVisible(false)} enableReturn={true} />
            )}

        </div>
    )
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(QuestionnairePage)
